import { Panel } from '../../../common/panel'
import SaveButton from './SaveButton'
import { InterestedIndustries } from './interestedIndustries'
import { InterestedLocations } from './interestedLocation'

export const Preferences = ({ userSettings }) => {
  return (
    <Panel label="settingPreferences.PREFERENCES" isI18n>
      <InterestedIndustries />
      <InterestedLocations />
      <SaveButton userSettings={userSettings} />
    </Panel>
  )
}
